import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import { getCookie } from "@workspace/cookies/browser";

const useIsMetamaskEnabled = () => {
  const BYPASS_COOKIE = !!parseInt(
    getCookie("METAMASK_STAGING_TEST") as string,
  );

  const isMetamaskEnabledFF = useFeature("isMetamaskEnabled");
  const { isMobile } = useAgentData();

  if (BYPASS_COOKIE) {
    return true;
  }

  if (isMobile && isMetamaskEnabledFF && global?.ethereum) {
    return true;
  }

  if (isMobile) {
    return false;
  }

  return isMetamaskEnabledFF;
};

export default useIsMetamaskEnabled;
